import React from 'react';

type BadgeVariant = 'success' | 'warning' | 'error' | 'info' | 'neutral' | 'gold';

interface BadgeProps {
  variant: BadgeVariant;
  children: React.ReactNode;
  className?: string;
}

const VARIANT_STYLES: Record<BadgeVariant, string> = {
  success: 'bg-green-50 text-green-700 border-green-200',
  warning: 'bg-amber-50 text-amber-700 border-amber-200',
  error: 'bg-red-50 text-red-700 border-red-200',
  info: 'bg-blue-50 text-blue-700 border-blue-200',
  neutral: 'bg-[hsl(var(--muted))] text-[hsl(var(--muted-foreground))] border-[hsl(var(--border))]',
  gold: 'bg-[hsl(var(--accent))]/10 text-[#8a6a1a] border-[hsl(var(--accent))]/30',
};

export default function Badge({ variant, children, className = '' }: BadgeProps) {
  return (
    <span data-component-id="src/components/ui/Badge.tsx:22:4" data-component-path="src/components/ui/Badge.tsx" data-component-line="22" data-component-end-line="24" data-component-file="Badge.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D" className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold border ${VARIANT_STYLES[variant]} ${className}`}>
      {children}
    </span>
  );
}